var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msg-analysis-video"},[_c('video',{attrs:{"controls":"controls","width":"260","height":"200"}},[_c('source',{attrs:{"src":_vm.message,"type":"video/mp4"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }